import {
  ADMIN_TOKEN_PARAM_NAME,
  applyPortalImpersonationCookies,
  getSafeRedirectPath,
  IMPERSONATE_ID_PARAM_NAME,
  REDIRECT_URL_PARAM_NAME,
} from '@repo/utils/portalImpersonation';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { createServerFn } from '@tanstack/react-start';

export const Route = createFileRoute('/impersonate')({
  preload: false,
  loader: async () => {
    await impersonateFn();
  },
  component: ImpersonateRoute,
});

const impersonateFn = createServerFn({ method: 'GET' }).handler(async () => {
  const { getWebRequest } = await import('@tanstack/react-start/server');
  const request = getWebRequest();
  if (!request) {
    throw new Error('Missing request context');
  }

  const url = new URL(request.url);
  const impersonateId =
    url.searchParams.get(IMPERSONATE_ID_PARAM_NAME) ?? undefined;
  const adminToken = url.searchParams.get(ADMIN_TOKEN_PARAM_NAME) ?? undefined;
  const redirectUrl = getSafeRedirectPath(
    url.searchParams.get(REDIRECT_URL_PARAM_NAME) ?? undefined,
  );

  if (!impersonateId || !adminToken) {
    throw redirect({
      to: '/',
      replace: true,
    });
  }

  const responseHeaders = new Headers();
  const context = { request, responseHeaders };

  applyPortalImpersonationCookies({ impersonateId, adminToken, context });

  throw redirect({
    to: redirectUrl,
    replace: true,
    headers: responseHeaders,
  });
});

function ImpersonateRoute() {
  return <div>Starting impersonation...</div>;
}
